export default __webpack_public_path__ + "static/media/WAS0030.34I-35113_-20198_0.e1735070.jpg";